import Swal from 'sweetalert2';
export const showSuccessAlert = async (error, title) => {
  const swalResult = await Swal.fire({
    toast: true,
    position: 'bottom-end',
    title: error,
    icon: 'success',
    timer: 3000,
    timerProgressBar: true,
    width: '420px',
    didOpen: () => {
      document.querySelector('.swal2-container')?.style.setProperty('z-index', '99999', 'important');
    },
    customClass: 'sweetalert-bootstrap-modal',
    showConfirmButton: false
  });

  // If you want to perform some action after the alert is closed, you can check the result
  if (swalResult.dismiss === Swal.DismissReason.timer) {
    // console.log('Alert closed after the timer elapsed.');
    // Perform additional actions if needed
  }
};

export const showSalesPerSuccessAlert = async (error, title) => {
  await Swal.fire({
    title: title,
    text: error,
    icon: 'success',
    confirmButtonText: 'Okay',
    confirmButtonColor: '#dc3545',
    showConfirmButton: true,
    showCloseButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    customClass: 'sweetalert-bootstrap-modal'
  });
};
